export default class ToastSchema {
    position = ['center', 'top'];
    content = {
        title: null,
        text: '',
        status: null, // color
        icon: ''
    }
    time = 3000;

    constructor(
        content,
        time = 3000,
        position = null
    ) {
        this.content.title = (content.title) ? content.title : null;
        this.content.text = (content.text) ? content.text : '';
        this.content.status = (content.status) ? content.status : 'alert';
        this.position = (position !== null) ? position : ['center', 'top'];
        this.time = time;
    }
}